<template lang="pug">
    .btn
        router-link(
            v-if="path"
            :to="path"
        )
            .solobutton(v-bind:style="{backgroundColor: buttonColor.background, color: buttonColor.font, borderColor: buttonColor.font}")
                font-awesome-icon(v-if="icon" class="icon" :icon="icon")
                h3(:style="{color: buttonColor.font}") {{button.title}}
                div.linkname(:style="{color: buttonColor.font}") {{button.hyperlink.name}}
        a(
            v-else-if="href"
            :href="href"
            :title="button.hyperlink.name"
            :target="target"
        )
            .solobutton(:style="{backgroundColor: buttonColor.background, color: buttonColor.font, borderColor: buttonColor.font}")
                font-awesome-icon(v-if="icon" class="icon" :icon="icon")
                h3(:style="{color: buttonColor.font}") {{button.title}}
                div.linkname(:style="{color: buttonColor.font}") {{button.hyperlink.name}}
        template(v-else)
            .solobutton(v-bind:style="{backgroundColor: buttonColor.background, color: buttonColor.font, borderColor: buttonColor.font}")
                font-awesome-icon(v-if="icon" class="icon" :icon="icon")
                h3(:style="{color: buttonColor.font}") {{button.title}}
                div.linkname(:style="{color: buttonColor.font}") {{button.hyperlink.name}}
</template>

<script>

import { get, startsWith } from 'lodash'
import Color from 'color'

export default {
    name: 'Button',
    props: {
        button: {
            type: Object,
            required: true,
        }
    },
    computed: {
        hyperlink() {
            return get(this.button, 'hyperlink') || {}
        },
        buttonsettings() {
            return get(this.button, 'settings') || []
        },
        buttonColor() {
            let fontColor = '#ffffff'
            const backgroundColor = get(this.button, 'color') || '#1b642b'

            if (Color(backgroundColor).lightness() > 60) {
                fontColor = '#636363'
            }

            return {
                'background': backgroundColor,
                'font': fontColor
            }
        },
        href() {
            let href = false

            if (this.hyperlink.type !== 'internal' && get(this.hyperlink, 'href')) {
                const link = this.hyperlink.href
                switch (this.hyperlink.type) {
                    case 'external':
                        if (! startsWith(link, 'https://') && ! startsWith(link, 'http://')) href = `https://${link}`
                        else href = link
                        break;

                    case 'mailto':
                        href = `mailto:${link}`
                        break;

                    case 'tel':
                        href = `tel:${link}`
                        break;
                }
            }

            return href
        },
        target() {
            return get(this.hyperlink, 'target') || '_self'
        },
        path() {
            if (this.hyperlink.type === 'internal' && get(this.hyperlink, 'menuItem.path')) return this.hyperlink.menuItem.path
            else return false
        },
        settings() {
            return this.buttonsettings.find(settings => settings.key === 'symbol')
        },
        icon() {
            return get(this.settings, 'value') || 'calendar'
        },
        linkText() {
            return get(this.hyperlink, 'name') || 'mehr...'
        }
    },
}
</script>

<style lang="sass" scoped>
    @import "~bulma/sass/utilities/mixins"
    @import '~@/assets/sass/variables'
    .btn
        height: 100%
        width: 100%
        min-width: 220px
        max-width: 260px
        display: flex
        margin: auto
        > a
            flex-grow: 1
            height: 100%
    .solobutton
        width: 100%
        height: 100%
        background-color: #ebf6cb
        padding: 15px
        border-radius: 15px
        text-align: center
        color: #fff
        transition: transform .3s ease, box-shadow .3s ease, background-color .3s ease
        display: flex
        flex-direction: column
        justify-content: space-between
        align-items: center
        &:hover
            // background-color: #80bb3d!important
            // color: #fff!important
            box-shadow: $box-shadow-3
            transform: scale(1.05)
        .icon
            font-size: 150%
            margin: 10px
            width: 50px
            height: 50px
        .linkname
            width: 75%
        h3
            font-size: 20px


</style>
